import { TranslateService } from '@ngx-translate/core';
import { roleValueIDs, TeacherRoleDescription, AdminRoleDescription } from '../../models/user';
import { RadioGroupInputOption } from '../../standalones/components/radio-group-input/radio-group-input.component';

export interface RoleDescriptionOption {
  value: TeacherRoleDescription | AdminRoleDescription;
  label: string;
}

export function buildStudentStatusOptions(
  translateService: TranslateService,
): RadioGroupInputOption[] {
  return [
    { id: 'yes', name: translateService.instant('Yes'), value: roleValueIDs.student },
    { id: 'no', name: translateService.instant('No'), value: roleValueIDs.teacher },
  ];
}

export function buildUserRoleOptions(translateService: TranslateService): RadioGroupInputOption[] {
  return [
    {
      id: roleValueIDs.student,
      name: translateService.instant('Student'),
      value: roleValueIDs.student,
    },
    {
      id: roleValueIDs.teacher,
      name: translateService.instant('Teacher'),
      value: roleValueIDs.teacher,
    },
    { id: roleValueIDs.admin, name: translateService.instant('Admin'), value: roleValueIDs.admin },
  ];
}

export function buildDescriptionOptionsMap(
  translateService: TranslateService,
): Record<string, RoleDescriptionOption[]> {
  return {
    [roleValueIDs.teacher]: [
      {
        value: TeacherRoleDescription.INDEPENDENT_TUTOR,
        label: translateService.instant('I am an independent tutor'),
      },
      {
        value: TeacherRoleDescription.TUTORING_COMPANY,
        label: translateService.instant('I teach at a tutoring company'),
      },
      {
        value: TeacherRoleDescription.SCHOOL,
        label: translateService.instant('I teach at a school'),
      },
      {
        value: TeacherRoleDescription.OTHER,
        label: translateService.instant('Other'),
      },
    ],
    [roleValueIDs.admin]: [
      {
        value: AdminRoleDescription.INDEPENDENT_TUTOR,
        label: translateService.instant('I am an independent tutor'),
      },
      {
        value: AdminRoleDescription.SMALL_TUTORING_COMPANY,
        label: translateService.instant('I run a small tutoring company (2-10 tutors)'),
      },
      {
        value: AdminRoleDescription.LARGE_TUTORING_COMPANY,
        label: translateService.instant('I run a large tutoring company (10+ tutors)'),
      },
      {
        value: AdminRoleDescription.SCHOOL,
        label: translateService.instant('I run a school'),
      },
      {
        value: AdminRoleDescription.PARENT,
        label: translateService.instant('I am a parent'),
      },
      {
        value: AdminRoleDescription.OTHER,
        label: translateService.instant('Other'),
      },
    ],
  };
}
